import { track } from '@ramp106/omrjs-tracking-reviews'

// Reaching out to a lead is the conversion the Leads section exists for, so it is a
// meaningful_action. `cta_click` has no free property slot, so the channel rides `cta_id`
// (the business distinction: email vs phone outreach) and the surface + how they took the
// address rides `cta_position` (diagnostic detail). Entity context is recovered at query
// time from the auto-captured `$current_url`, which carries /reviews/:id and /agencies/:id.
type LeadContactChannel = 'email' | 'phone'
type LeadContactSurface = 'leads_list' | 'lead_detail'
type LeadContactMethod = 'mailto' | 'tel' | 'copy'

// Literal per channel rather than an interpolated string, so both ids stay greppable.
const CTA_ID_BY_CHANNEL: Record<LeadContactChannel, string> = {
  email: 'lead_contact_email',
  phone: 'lead_contact_phone',
}

export function trackLeadContact(channel: LeadContactChannel, surface: LeadContactSurface, method: LeadContactMethod): void {
  track('cta_click', {
    surface: 'cta',
    category: 'meaningful_action',
    cta_id: CTA_ID_BY_CHANNEL[channel],
    cta_position: `${surface}_${method}`,
  })
}
